import { render } from "./LandSubdivisionPackageDeleteModal.vue?vue&type=template&id=07504b73&scoped=true&ts=true&lang=pug"
import script from "./LandSubdivisionPackageDeleteModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandSubdivisionPackageDeleteModal.vue?vue&type=script&lang=ts&setup=true"

import "./LandSubdivisionPackageDeleteModal.vue?vue&type=style&index=0&id=07504b73&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07504b73"]])

export default __exports__